import React from 'react'
import "./AboutUsStyles.css"

function AboutUs() {
  return (
    <div className='aboutContainer'>
        <h1>Our Mission</h1>
        <p>Lorem ipsum, dolor sit amet consectetur adipisicing 
            elit. Perferendis sint saepe eveniet? 
            Maxime unde error corporis facilis voluptate
             assumenda ullam, quae, sed optio at commodi?</p>

             <h1>Our Vission</h1>
        <p>Lorem ipsum, dolor sit amet consectetur adipisicing 
            elit. Perferendis sint saepe eveniet? 
            Maxime unde error corporis facilis voluptate
             assumenda ullam, quae, sed optio at commodi?</p>

             <h1>Our History</h1>
        <p>Lorem ipsum, dolor sit amet consectetur adipisicing 
            elit. Perferendis sint saepe eveniet? 
            Maxime unde error corporis facilis voluptate
             assumenda ullam, quae, sed optio at commodi?</p>
    </div>
  )
}

export default AboutUs